import { Navigate, Route, Routes, useLocation, Outlet } from "react-router-dom";
import LoginPage from "../pages/auth/LoginPage";
import ResetPasswordPage from "../pages/auth/ResetPasswordPage";
import ForgotPasswordPage from "pages/auth/ForgotPasswordPage";

const GuestRoutes = () => {
  const location = useLocation();

  return (
    <Routes>
      <Route exact path="/" element={<Outlet />}>
        <Route exact path="/" element={<LoginPage />} />
        <Route exact path="/reset-password" element={<ResetPasswordPage />} />
        <Route exact path="/forgot-password" element={<ForgotPasswordPage />} />
      </Route>
      <Route
        path="*"
        element={<Navigate to="/" state={{ from: location }} />}
      />
    </Routes>
  );
};

export default GuestRoutes;
